import {addEventListenerIfExist, getUrlVars} from './utils';
import {errorHandler, request} from './HttpClient';

export default class VarianteAdmin {
	constructor(app) {
		this.app = app;
		const self = this;

		// save the changes
		addEventListenerIfExist('click', e => {
			e.preventDefault();
			const submitbtn = e.target;
			submitbtn.classList.replace('btn--primary', 'is-loading');

			const form = submitbtn.closest('.section').querySelector('.js-form');
			request(form.action, {
				method: 'POST',
				params: form,
			})
				.then(req => req.text())
				.then(data => {
					console.log(data)
					submitbtn.classList.replace('is-loading', 'btn--primary');
					submitbtn.closest('.section').querySelector('.js-done_switch').click(); // hide section
				})
				.catch(errorHandler)
		}, '.js-varianteadmin-form-submit');


		// toggle section (view/hide)
		addEventListenerIfExist('change', e => {
			e.target.closest('.section').querySelector('.js-form')
				.classList.toggle('is-hidden');
		}, '.js-done_switch');

		// search on enter
		addEventListenerIfExist('keypress', e => {
			if (e.which === 13) { // on enter
				self.doSearch(e);
				return false;
			}
		}, '.js-search-input');

		// search on button click
		addEventListenerIfExist('click', self.doSearch, '.js-search-btn');
	}

	/**
	 * Do the search by building the related URL and redirecting.
	 * @param {Event} e The triggered event.
	 */
	doSearch(e) {
		e.preventDefault();

		const newParams = new URLSearchParams();
		getUrlVars().forEach((value, key) => {
			if (key !== 'search' && key !== 'page') {
				newParams.set(key, value);
			}
		});
		newParams.set('search', document.querySelector('.js-search-input').value);

		window.location.href = `${window.location.origin}${window.location.pathname}?${newParams.toString()}`;
	}
}

